module.exports = __webpack_public_path__ + "img/Techmedia_Logo_Neg_Colour-TL.1f9eac93.png";